import React, { useEffect, useState } from "react";

import AOS from "aos";
import "aos/dist/aos.css";
import "../../css/Mirissa.css";

import { storage } from "../../firebase";
import { ref, getDownloadURL } from "firebase/storage";

function Mirissa() {

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [imgHero, setImgHero] = useState("");

  // TOP GALLERY
  const [mirissa1, setMirissa1] = useState("");
  const [mirissa2, setMirissa2] = useState("");

  // EXTRA GALLERY
  const [mirissa3, setMirissa3] = useState("");
  const [mirissa4, setMirissa4] = useState("");
  const [mirissa5, setMirissa5] = useState("");

  // ACTIVITY ICONS (Surfing section)
  const [surfing, setSurfing] = useState("");
  const [beginnerGuide, setBeginnerGuide] = useState("");
  const [relaxing, setRelaxing] = useState("");

  // SNORKELING / DIVING ICONS
  const [whaleWatching, setWhaleWatching] = useState("");
  const [turtleWatching, setTurtleWatching] = useState("");
  const [turtleFeeding, setTurtleFeeding] = useState("");

  // FISHING ICONS
  const [boatFishing, setBoatFishing] = useState("");
  const [fishing, setFishing] = useState("");
  const [traditionalFishing, setTraditionalFishing] = useState("");

  // PARROT ROCK GALLERY
  const [mirissa6, setMirissa6] = useState("");
  const [mirissa7, setMirissa7] = useState("");

  useEffect(() => {

    getDownloadURL(ref(storage, "mirissa-hero.jpg")).then(setImgHero);

    // TOP GALLERY
    getDownloadURL(ref(storage, "mirissa1.jpg")).then(setMirissa1);
    getDownloadURL(ref(storage, "mirissa2.jpg")).then(setMirissa2);

    // EXTRA GALLERY
    getDownloadURL(ref(storage, "mirissa3.jpg")).then(setMirissa3);
    getDownloadURL(ref(storage, "mirissa4.jpg")).then(setMirissa4);
    getDownloadURL(ref(storage, "mirissa5.jpg")).then(setMirissa5);

    // SURFING ICONS
    getDownloadURL(ref(storage, "Surfing.png")).then(setSurfing);
    getDownloadURL(ref(storage, "Beginner Guide.png")).then(setBeginnerGuide);
    getDownloadURL(ref(storage, "Relaxing.png")).then(setRelaxing);

    // SNORKELING ICONS
    getDownloadURL(ref(storage, "Whale Watching.png")).then(setWhaleWatching);
    getDownloadURL(ref(storage, "Turtle Watching.png")).then(setTurtleWatching);
    getDownloadURL(ref(storage, "Turtle Feeding.png")).then(setTurtleFeeding);

    // FISHING ICONS
    getDownloadURL(ref(storage, "Boating.png")).then(setBoatFishing);
    getDownloadURL(ref(storage, "Fishing.png")).then(setFishing);
    getDownloadURL(ref(storage, "Traditional Fishing.png")).then(
      setTraditionalFishing
    );

    // PARROT ROCK
    getDownloadURL(ref(storage, "mirissa6.jpg")).then(setMirissa6);
    getDownloadURL(ref(storage, "mirissa.jpg")).then(setMirissa7);

  }, []);

  return (
    <div className="destination-container">
      {/* HERO SECTION */}
      <section
        className="mirissa-hero"
        style={{ backgroundImage: `url(${imgHero})` }}
        data-aos="fade-down"
      >
        <div className="overlay">
          <h1>Mirissa</h1>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <section className="mirissa-container">
        {/* LEFT CONTENT */}
        <div className="mirissa-left" data-aos="fade-right">

          <h2>Mirissa</h2>
          <p>
            Hidden gem in southern beach, with many attractions such as coconut tree hill,
            whale watching, parrot rock, surfing, snorkeling & diving, beach relaxation.
          </p>

          <p>
            Mirissa is a popular tourist destination in Sri Lanka, and most visitors come
            to Mirissa Beach for a specialty in the winter.
          </p>

          <div className="mirissa-gallery">
            <img src={mirissa1} alt="Mirissa View" />
            <img src={mirissa2} alt="Mirissa Beach" />
          </div>

          <h3>Coconut Tree Hill</h3>
          <p>
            Coconut tree Hill has recently become one of Sri Lanka's most popular tourist destinations,
            located in the Mirissa region in the Southern Province. It is a small dome-shaped hill surrounded by palm trees.
            The Coconut Hill is one place you should not miss during your trip to the south of Sri Lanka.
            This a private coconut farm that is open all day and welcomes the public to visit. You don't need to buy tickets to enter.
            Once you get there, you'll see stunning views of the Indian Ocean. This place is completely covered with palm trees,
            and you can take stunning photos to post on Instagram. The sea breeze will help you feel more comfortable and relax.
          </p>

          <h3>Whale Watching</h3>
          <p>
            This is a great place to see whales in this beautiful country southern part in addition to trincomalee in eastern part.
          </p>

          <h3>Routes to Coconut Tree Hill</h3>
          <ul className="mirissa-list">
            <li>Through the beach of Mirissa</li>
            <li>Through the Bandaramwela Temple</li>
          </ul>

          {/* EXTRA CONTENT FROM SCREENSHOT */}
          <div className="mirissa-extra" data-aos="fade-up">

            <div className="mirissa-top-gallery">
              <img src={mirissa3} alt="Surfing" />
              <img src={mirissa4} alt="Snorkeling with Turtle" />
              <img src={mirissa5} alt="Boat Fishing" />
            </div>

            <h3>Most of the tourists and visitors come to this place through Mirissa beach.</h3>

            <p>
              If you drive or do not want to walk on the beach, you can get there through the
              Bandaramulla Temple. However, regardless of the path you choose, you will have to
              overcome a difficult path to reach your goal.
            </p>

            <p>
              Mirissa is usually crowded every day, both locals and foreigners. But if you can get
              there in the morning, you can enjoy a wonderful sunrise in a less crowded environment.
              Before 9 a.m., there are fewer people, which is something to consider before your visit.
            </p>

            <p>
              Sunset is a great time to visit the Palm Mountains. The weather report explains that
              the rainy season in the region is from October to December. The best time to visit is
              from January to May. Another factor to consider is that the beach is closed during the
              monsoon season from May to September.
            </p>

          </div>

          {/* ACTIVITIES SECTION */}
          <div className="mirissa-activities" data-aos="fade-up">

            <h2>Activities.</h2>
            <p>You have below activities in Mirissa beach.</p>

            {/* SURFING */}
            <details className="activity-box" open>
              <summary>• Surfing: Ideal for beginners and intermediate surfers.</summary>

              <p>
                Ride the waves in Mirissa’s crystal-clear waters, perfect for beginners and intermediate surfers
                seeking thrilling experiences.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={surfing} alt="Surfing" />
                  <p>Surfing</p>
                </div>

                <div className="activity-card">
                  <img src={beginnerGuide} alt="Beginner Guide" />
                  <p>Beginner Guide</p>
                </div>

                <div className="activity-card">
                  <img src={relaxing} alt="Relaxing" />
                  <p>Relaxing</p>
                </div>
              </div>
            </details>

            {/* SNORKELING */}
            <details className="activity-box">
              <summary>• Snorkeling & Diving: Explore vibrant coral reefs and marine life.</summary>

              <p>
                Discover vibrant coral reefs teeming with colorful fish and marine life,
                creating unforgettable underwater adventures.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={whaleWatching} alt="Whale Watching" />
                  <p>Whale Watching</p>
                </div>

                <div className="activity-card">
                  <img src={turtleWatching} alt="Turtle Watching" />
                  <p>Turtle Watching</p>
                </div>

                <div className="activity-card">
                  <img src={turtleFeeding} alt="Turtle Feeding" />
                  <p>Turtle Feeding</p>
                </div>
              </div>
            </details>

            {/* FISHING */}
            <details className="activity-box">
              <summary>• Fishing Tours: Experience traditional Sri Lankan fishing.</summary>

              <p>
                Join traditional Sri Lankan fishing tours, enjoy serene coastal views,
                and learn age-old fishing techniques firsthand.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={boatFishing} alt="Boating" />
                  <p>Boating</p>
                </div>

                <div className="activity-card">
                  <img src={fishing} alt="Fishing" />
                  <p>Fishing</p>
                </div>

                <div className="activity-card">
                  <img src={traditionalFishing} alt="Traditional Fishing" />
                  <p>Traditional Fishing</p>
                </div>
              </div>
            </details>
          </div>

          {/* PARROT ROCK SECTION */}
          <div className="mirissa-parrot-rock" data-aos="fade-up">

            <h3>Parrot Rock</h3>
            <p>• A small rocky islet offering beautiful views of the coastline, reachable during low tide.</p>

            <div className="parrot-gallery">
              <img src={mirissa6} alt="Parrot Rock" />
              <img src={mirissa7} alt="Seafood Dish" />
            </div>

            <h3>You can spend your time here unlimitedly.</h3>
          </div>

        </div>

        {/* RIGHT INQUIRY FORM */}
        <div className="mirissa-form" data-aos="fade-left">
          <h3>Make an Inquiry</h3>

          <form
            onSubmit={(e) => {
              e.preventDefault();

              const name = e.target.name.value;
              const email = e.target.email.value;
              const country = e.target.country.value;
              const code = e.target.code.value;
              const phone = e.target.phone.value;
              const arrival = e.target.arrival.value;
              const departure = e.target.departure.value;
              const interest = e.target.interest.value;
              const vehicle = e.target.vehicle.value;   // ✅ NEW
              const adults = e.target.adults.value;
              const kids = e.target.kids.value;
              const message = e.target.message.value;

              const fullMessage = `
                📌 NEW TOUR BOOKING

                👤 Name: ${name}
                📧 Email: ${email}
                🌍 Country: ${country}
                📞 Phone: ${code} ${phone}
                📅 Arrival: ${arrival}
                📅 Departure: ${departure}
                🎯 Interest: ${interest}
                🚗 Vehicle Preference: ${vehicle}
                👨‍👩‍👧 Adults: ${adults}
                🧒 Kids: ${kids}

                💬 Message: ${message} 
              `;

              // ✅ SEND WHATSAPP
              const whatsappNumber = "94773562768"; // your WhatsApp number
              const whatsappURL =
                "https://wa.me/" + whatsappNumber + "?text=" + encodeURIComponent(fullMessage);

              window.open(whatsappURL, "_blank");

              // ✅ SEND EMAIL
              const mailto =
                "mailto:ceylongracetravels@gmail.com" +
                "?subject=" + encodeURIComponent("New Tour Booking") +
                "&body=" + encodeURIComponent(fullMessage);

              window.location.href = mailto;

              alert("✅ Your Booking is Send!");
            }}
          >
            <input name="name" type="text" placeholder="Name *" />
            <input name="email" type="email" placeholder="Email Address *" />

            <select name="country" required>
              <option value="">Choose Your Country *</option>
              <option value="Afghanistan">Afghanistan</option>
              <option value="Albania">Albania</option>
              <option value="Algeria">Algeria</option>
              <option value="Andorra">Andorra</option>
              <option value="Angola">Angola</option>
              <option value="Antigua and Barbuda">Antigua and Barbuda</option>
              <option value="Argentina">Argentina</option>
              <option value="Armenia">Armenia</option>
              <option value="Australia">Australia</option>
              <option value="Austria">Austria</option>
              <option value="Azerbaijan">Azerbaijan</option>
              <option value="Bahamas">Bahamas</option>
              <option value="Bahrain">Bahrain</option>
              <option value="Bangladesh">Bangladesh</option>
              <option value="Barbados">Barbados</option>
              <option value="Belarus">Belarus</option>
              <option value="Belgium">Belgium</option>
              <option value="Belize">Belize</option>
              <option value="Benin">Benin</option>
              <option value="Bhutan">Bhutan</option>
              <option value="Bolivia">Bolivia</option>
              <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
              <option value="Botswana">Botswana</option>
              <option value="Brazil">Brazil</option>
              <option value="Brunei">Brunei</option>
              <option value="Bulgaria">Bulgaria</option>
              <option value="Burkina Faso">Burkina Faso</option>
              <option value="Burundi">Burundi</option>
              <option value="Cabo Verde">Cabo Verde</option>
              <option value="Cambodia">Cambodia</option>
              <option value="Cameroon">Cameroon</option>
              <option value="Canada">Canada</option>
              <option value="Central African Republic">Central African Republic</option>
              <option value="Chad">Chad</option>
              <option value="Chile">Chile</option>
              <option value="China">China</option>
              <option value="Colombia">Colombia</option>
              <option value="Comoros">Comoros</option>
              <option value="Congo, Democratic Republic of the">Congo, Democratic Republic of the</option>
              <option value="Congo, Republic of the">Congo, Republic of the</option>
              <option value="Costa Rica">Costa Rica</option>
              <option value="Côte d’Ivoire">Côte d’Ivoire</option>
              <option value="Croatia">Croatia</option>
              <option value="Cuba">Cuba</option>
              <option value="Cyprus">Cyprus</option>
              <option value="Czech Republic">Czech Republic</option>
              <option value="Denmark">Denmark</option>
              <option value="Djibouti">Djibouti</option>
              <option value="Dominica">Dominica</option>
              <option value="Dominican Republic">Dominican Republic</option>
              <option value="Ecuador">Ecuador</option>
              <option value="Egypt">Egypt</option>
              <option value="El Salvador">El Salvador</option>
              <option value="Equatorial Guinea">Equatorial Guinea</option>
              <option value="Eritrea">Eritrea</option>
              <option value="Estonia">Estonia</option>
              <option value="Eswatini">Eswatini</option>
              <option value="Ethiopia">Ethiopia</option>
              <option value="Fiji">Fiji</option>
              <option value="Finland">Finland</option>
              <option value="France">France</option>
              <option value="Gabon">Gabon</option>
              <option value="Gambia">Gambia</option>
              <option value="Georgia">Georgia</option>
              <option value="Germany">Germany</option>
              <option value="Ghana">Ghana</option>
              <option value="Greece">Greece</option>
              <option value="Grenada">Grenada</option>
              <option value="Guatemala">Guatemala</option>
              <option value="Guinea">Guinea</option>
              <option value="Guinea-Bissau">Guinea-Bissau</option>
              <option value="Guyana">Guyana</option>
              <option value="Haiti">Haiti</option>
              <option value="Honduras">Honduras</option>
              <option value="Hungary">Hungary</option>
              <option value="Iceland">Iceland</option>
              <option value="India">India</option>
              <option value="Indonesia">Indonesia</option>
              <option value="Iran">Iran</option>
              <option value="Iraq">Iraq</option>
              <option value="Ireland">Ireland</option>
              <option value="Israel">Israel</option>
              <option value="Italy">Italy</option>
              <option value="Jamaica">Jamaica</option>
              <option value="Japan">Japan</option>
              <option value="Jordan">Jordan</option>
              <option value="Kazakhstan">Kazakhstan</option>
              <option value="Kenya">Kenya</option>
              <option value="Kiribati">Kiribati</option>
              <option value="Korea, North">Korea, North</option>
              <option value="Korea, South">Korea, South</option>
              <option value="Kuwait">Kuwait</option>
              <option value="Kyrgyzstan">Kyrgyzstan</option>
              <option value="Laos">Laos</option>
              <option value="Latvia">Latvia</option>
              <option value="Lebanon">Lebanon</option>
              <option value="Lesotho">Lesotho</option>
              <option value="Liberia">Liberia</option>
              <option value="Libya">Libya</option>
              <option value="Liechtenstein">Liechtenstein</option>
              <option value="Lithuania">Lithuania</option>
              <option value="Luxembourg">Luxembourg</option>
              <option value="Madagascar">Madagascar</option>
              <option value="Malawi">Malawi</option>
              <option value="Malaysia">Malaysia</option>
              <option value="Maldives">Maldives</option>
              <option value="Mali">Mali</option>
              <option value="Malta">Malta</option>
              <option value="Marshall Islands">Marshall Islands</option>
              <option value="Mauritania">Mauritania</option>
              <option value="Mauritius">Mauritius</option>
              <option value="Mexico">Mexico</option>
              <option value="Micronesia">Micronesia</option>
              <option value="Moldova">Moldova</option>
              <option value="Monaco">Monaco</option>
              <option value="Mongolia">Mongolia</option>
              <option value="Montenegro">Montenegro</option>
              <option value="Morocco">Morocco</option>
              <option value="Mozambique">Mozambique</option>
              <option value="Myanmar (Burma)">Myanmar (Burma)</option>
              <option value="Namibia">Namibia</option>
              <option value="Nauru">Nauru</option>
              <option value="Nepal">Nepal</option>
              <option value="Netherlands">Netherlands</option>
              <option value="New Zealand">New Zealand</option>
              <option value="Nicaragua">Nicaragua</option>
              <option value="Niger">Niger</option>
              <option value="Nigeria">Nigeria</option>
              <option value="North Macedonia">North Macedonia</option>
              <option value="Norway">Norway</option>
              <option value="Oman">Oman</option>
              <option value="Pakistan">Pakistan</option>
              <option value="Palau">Palau</option>
              <option value="Panama">Panama</option>
              <option value="Papua New Guinea">Papua New Guinea</option>
              <option value="Paraguay">Paraguay</option>
              <option value="Peru">Peru</option>
              <option value="Philippines">Philippines</option>
              <option value="Poland">Poland</option>
              <option value="Portugal">Portugal</option>
              <option value="Qatar">Qatar</option>
              <option value="Romania">Romania</option>
              <option value="Russia">Russia</option>
              <option value="Rwanda">Rwanda</option>
              <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
              <option value="Saint Lucia">Saint Lucia</option>
              <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
              <option value="Samoa">Samoa</option>
              <option value="San Marino">San Marino</option>
              <option value="Sao Tome and Principe">Sao Tome and Principe</option>
              <option value="Saudi Arabia">Saudi Arabia</option>
              <option value="Senegal">Senegal</option>
              <option value="Serbia">Serbia</option>
              <option value="Seychelles">Seychelles</option>
              <option value="Sierra Leone">Sierra Leone</option>
              <option value="Singapore">Singapore</option>
              <option value="Slovakia">Slovakia</option>
              <option value="Slovenia">Slovenia</option>
              <option value="Solomon Islands">Solomon Islands</option>
              <option value="Somalia">Somalia</option>
              <option value="South Africa">South Africa</option>
              <option value="South Sudan">South Sudan</option>
              <option value="Spain">Spain</option>
              <option value="Sri Lanka">Sri Lanka</option>
              <option value="Sudan">Sudan</option>
              <option value="Suriname">Suriname</option>
              <option value="Sweden">Sweden</option>
              <option value="Switzerland">Switzerland</option>
              <option value="Syria">Syria</option>
              <option value="Taiwan">Taiwan</option>
              <option value="Tajikistan">Tajikistan</option>
              <option value="Tanzania">Tanzania</option>
              <option value="Thailand">Thailand</option>
              <option value="Timor-Leste">Timor-Leste</option>
              <option value="Togo">Togo</option>
              <option value="Tonga">Tonga</option>
              <option value="Trinidad and Tobago">Trinidad and Tobago</option>
              <option value="Tunisia">Tunisia</option>
              <option value="Turkey">Turkey</option>
              <option value="Turkmenistan">Turkmenistan</option>
              <option value="Tuvalu">Tuvalu</option>
              <option value="Uganda">Uganda</option>
              <option value="Ukraine">Ukraine</option>
              <option value="United Arab Emirates">United Arab Emirates</option>
              <option value="United Kingdom">United Kingdom</option>
              <option value="United States">United States</option>
              <option value="Uruguay">Uruguay</option>
              <option value="Uzbekistan">Uzbekistan</option>
              <option value="Vanuatu">Vanuatu</option>
              <option value="Vatican City">Vatican City</option>
              <option value="Venezuela">Venezuela</option>
              <option value="Vietnam">Vietnam</option>
              <option value="Yemen">Yemen</option>
              <option value="Zambia">Zambia</option>
              <option value="Zimbabwe">Zimbabwe</option>
            </select>

            <div className="phone-row">
              <input name="code" className="code" type="text" placeholder="Code" />
              <input name="phone" className="phone" type="text" placeholder="Phone Number *" />
            </div>

            <label htmlFor="arrival">Arrival Date</label>
            <input name="arrival" type="date" />

            <label htmlFor="departure">Departure Date</label>
            <input name="departure" type="date" />

            <select name="interest">
              <option value="">Choose Your Interest *</option>
              <option value="Eco">Eco</option>
              <option value="Beach">Beach</option>
              <option value="Cultural">Cultural</option>
              <option value="Adventure">Adventure</option>
              <option value="Wild Life">Wild Life</option>
              <option value="Relax and Wellness">Relax and Wellness</option>
              <option value="Honeymoon">Honeymoon</option>
              <option value="Ramayana Trail">Ramayana Trail</option>
              <option value="All in one Trails">All in one Trails</option>
            </select>

            <select name="vehicle">
              <option value="">Select Vehicle Type *</option>
              <option value="Sedan – Toyota Prius (3 Pax)">Sedan – Toyota Prius (3 Pax)</option>
              <option value="Sedan – Toyota Axio (3 Pax)">Sedan – Toyota Axio (3 Pax)</option>
              <option value="Sedan – Honda Grace (3 Pax)">Sedan – Honda Grace (3 Pax)</option>
              <option value="Mini – Suzuki Wagon R (2 Pax)">Mini – Suzuki Wagon R (2 Pax)</option>
              <option value="Mini – Toyota Aqua (2 Pax)">Mini – Toyota Aqua (2 Pax)</option>
              <option value="Van – Suzuki Every (4 Pax)">Van – Suzuki Every (4 Pax)</option>
              <option value="Van – Mini Van (4 Pax)">Van – Mini Van (4 Pax)</option>
              <option value="Van – Toyota Noha (4 Pax)">Van – Toyota Noha (4 Pax)</option>
              <option value="Bus – Mitsubishi Rosa (12 Pax)">Bus – Mitsubishi Rosa (12 Pax)</option>
              <option value="Bus – King Long (12 Pax)">Bus – King Long (12 Pax)</option>
            </select>

            <input name="adults" type="number" placeholder="Adults *" />
            <input name="kids" type="number" placeholder="Kids" />

            <textarea name="message" placeholder="Enter your message"></textarea>

            <button type="submit">SUBMIT</button>
          </form>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section" data-aos="fade-up">
        <div className="cta-box">
          <div className="cta-left">
            <img src={require("../../assets/hile.png")} className="cta-icon" alt="icon" />
            <div className="cta-text">
              <h2>Ready To Adventure And Enjoy Natural</h2>
              <p>Reach Pearl Ceylon Tours For A Secure, Luxurious, And Unforgettable Adventure!</p>
            </div>
          </div>

          <img src={require("../../assets/plan.png")} className="cta-plane" alt="plane" />

          <button className="cta-btn">LET’S GET STARTED</button>
        </div>
      </section>
    </div>
  );
}

export default Mirissa;
